import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout.component';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { icb_dashboardComponent } from '../icb_dashboard/icb_dashboard.component';
import { InspectionComponent } from '../inspection/inspection.component';
import { adminComponent } from '../admin/admin.component';
import { FocRequestComponent } from '../foc_request/foc_request.component';
import { FocDashboardComponent } from '../foc-dashboard/foc-dashboard.component';
import { HomeComponent } from '../home/home.component';
import { ProgressStatusComponent } from '../progress-status/progress.component';
import { FocAdminComponent } from '../foc-admin/foc-admin.component';
const routes: Routes = [
    {
        path: 'app',
        component: LayoutComponent,
        children: [
            { path: '', redirectTo: '/app/dashboard', pathMatch: 'full' },
            { path: 'dashboard', component: DashboardComponent },
            { path: 'home', component: HomeComponent },
            { path: 'icb/dashboard', component: icb_dashboardComponent },
            { path: 'chart', loadChildren: '../charts/charts.module#ChartsModule' },
            { path: 'ecommerce', loadChildren: '../ecommerce/ecommerce.module#ECommerceModule' },
            { path: 'form', loadChildren: '../forms/forms.module#MyFormsModule' },
            { path: 'page', loadChildren: '../pages/pages.module#PagesModule' },
            { path: 'pglayout', loadChildren: '../page-layouts/page-layouts.module#PageLayoutsModule' },
            { path: 'table', loadChildren: '../tables/tables.module#MyTablesModule' },
            { path: 'ui', loadChildren: '../ui/ui.module#UIModule' },
            { path: 'requests', loadChildren: '../request-mgmt/requests.module#RequestsModule' },
            { path: 'icb', loadChildren: '../icb/icb.module#IcbModule' },
            { path: 'view', loadChildren: '../viewRequest/viewrequests.module#viewRequestsModule' },
            { path: 'trade', loadChildren: '../trade/trade.module#TradesModule' },
            { path: 'inspection',component:InspectionComponent},
            { path: 'admin', component:adminComponent},
            {path: 'foc_request', component: FocRequestComponent},  
            {path: 'foc_dashboard', component: FocDashboardComponent},
            {path: 'foc_admin', component: FocAdminComponent},
            {path: 'focrequests', loadChildren: '../request-mgmt-foc/foc-requests.module#FOCRequestsModule'},
            {path: 'foc-view', loadChildren: '../FOCviewRequest/foc-viewrequests.module#FOCviewRequestsModule' },


            ]
    }
];

export const LayoutRoutingModule = RouterModule.forChild(routes);




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/layout-routing.module.ts